import { render, staticRenderFns } from "./channelTimeList.vue?vue&type=template&id=f391f96e&scoped=true&"
import script from "./channelTimeList.vue?vue&type=script&lang=js&"
export * from "./channelTimeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f391f96e",
  null
  
)

export default component.exports